var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadGlassesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 15.751H21.75",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 18.751H21.75",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 9.75098C8.82107 9.75098 10.5 8.07204 10.5 6.00098C10.5 3.92991 8.82107 2.25098 6.75 2.25098C4.67893 2.25098 3 3.92991 3 6.00098C3 8.07204 4.67893 9.75098 6.75 9.75098Z",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 9.75098C19.3211 9.75098 21 8.07204 21 6.00098C21 3.92991 19.3211 2.25098 17.25 2.25098C15.1789 2.25098 13.5 3.92991 13.5 6.00098C13.5 8.07204 15.1789 9.75098 17.25 9.75098Z",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.07178C10.5 5.24335 11.1716 4.57178 12 4.57178C12.8284 4.57178 13.5 5.24335 13.5 6.07178",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 6.00098H21",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.00098H0.75",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 21.751H3.75C2.09315 21.751 0.75 20.4078 0.75 18.751V15.751C0.75 14.0941 2.09315 12.751 3.75 12.751H23.25",
    stroke: "#303335",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadGlassesIcon);
export default __webpack_public_path__ + "static/media/readGlassesIcon.e5bd0ca9f67da0040115554b01986100.svg";
export { ForwardRef as ReactComponent };